// Smooth-scroll helpers for single-page navigation.
// Sections use the `scroll-mt-*` utilities to offset the fixed navbar.

export function scrollToSection(sectionId: string) {
  document
    .getElementById(sectionId)
    ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

export function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}
